import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const ServiceSection = ({ id }) => {
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchData = async () => {
    try {
      const response = await corefetch(
        `Services/GetServicesDetailsByDisplayedIniD?displayedInID=${id}`
      );

      if (response && response.length > 0) {
        const mappedServices = response.map((service) => ({
          ...service,
          image: `${ImageURL}${service.imagePath}`,
        }));
        setServices(mappedServices);
      } else {
        setServices([]);
      }
    } catch (error) {
      setServices([]);
      console.error("Error fetching services:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (services?.length) {
      if ($(".services-carousel").length) {
        $(".services-carousel").owlCarousel({
          loop: true,
          margin: 30,
          autoHeight: false,
          autoplay: true,
          autoplayTimeout: 3000,
          dots: false,
          nav: true,
          navText: [
            '<i class="ti-angle-left" aria-hidden="true"></i>',
            '<i class="ti-angle-right" aria-hidden="true"></i>',
          ],
          responsiveClass: true,
          responsive: {
            0: { dots: false, items: 1 },
            600: { dots: false, items: 2 },
            1000: { dots: false, items: 3 },
          },
        });

        // 🧠 Fix for cloned items - event delegation
        $(".services-carousel").on(
          "click",
          ".service-popup-trigger",
          function () {
            const index = $(this).data("service-index");
            if (index !== undefined && services[index]) {
              setSelectedService(services[index]);
              setIsModalOpen(true);
            }
          }
        );
      }
    }
  }, [services]);

  const openModal = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedService(null);
    setIsModalOpen(false);
  };

  if (!services || services.length === 0) {
    return null;
  }

  return (
    <>
      <section className="services section-padding">
        <div className="container">
          <div className="row mb-30">
            <div className="col-md-3">
              <div className="sub-title border-bot-light">Discover</div>
            </div>
            <div className="col-md-9">
              <div className="section-title">Our Services</div>
            </div>
          </div>

          {/* Owl Carousel */}
          <div className="services-carousel owl-theme owl-carousel">
            {services.map((service, index) => (
              <div key={index} className="item">
                <div className="item-wrap">
                  <div className="img">
                    <img
                      style={{ objectFit: "cover", cursor: "pointer" }}
                      src={service.image}
                      alt={service.serviceType}
                      className="service-popup-trigger"
                      data-service-index={index}
                    />
                  </div>
                  <div className="con">
                    <div className="title-box">
                      <h3>{service.serviceType}</h3>
                    </div>
                    <div className="arrow">
                      <a
                        data-service-index={index}
                        className="service-popup-trigger"
                        style={{ cursor: "pointer" }}
                      >
                        <span className="ti-arrow-right" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {isModalOpen && selectedService && (
        <div id="ServiceModal" className="popup">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-header">{selectedService.serviceType}</div>
            <div className="additional-text">
              <p>{selectedService.description}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ServiceSection;
